import { BatchesService } from '@festina/datamart2-general-types/datamart2/services/BatchesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method = BatchesService.batchesServiceDeleteDelete
type MethodParam = Parameters<typeof method>[0]

export const useDeleteDatamart2Batch = () =>
  useFestinaMutation({
    component: 'dataMart2',
    isScenario: false,
    roles: BatchesService.batchesServiceDeleteDelete_roles,
    mutateFunction: (arg: MethodParam) => method(arg),
  })
